import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkButton from '../../components/buttons/LinkButton';
import WhiteSectionContainer from '../../components/containers/WhiteSectionContainer';
import SectionHeader from '../../components/headers/SectionHeader';
import { publicLicensesAccountsPath, publicLicensesPath } from '../../constants';

const LicenseSection = (): React.ReactElement => {
    const { t: txt } = useTranslation();
    return (
        <div>
            <SectionHeader headerName="SwLicense.Licenses" headerType={3} />
            <WhiteSectionContainer>
                <p>{txt('SwLicense.LinkToLicenseDescription')}</p>
                <LinkButton link={publicLicensesPath} title="SwLicense.LinkToDashboardLicenses" />
                <LinkButton link={publicLicensesAccountsPath} title="SwLicense.LinkToAccountLicenses" />
            </WhiteSectionContainer>
        </div>
    );
};

export default LicenseSection;
